export default {
  1528: '#80cbc4',
  1534: '#20a8d8',
  1522: '#b39ddb',
  1536: '#bcaaa4',
  1529: '#a5d6a7',
  1527: '#80dee9',
  1525: '#90caf8',
  1537: '#b0bec5',
  1531: '#76fe03',
  1535: '#feab91',
  77: '#ce93d8',
  1532: '#e5ed9c',
  1526: '#81d4f9',
  1530: '#c5e1a5',
  1533: '#008000',
  1524: '#9fa8da',
  1538: '#b263aa',
  1539: '#da9d89',
  1540: '#bac9f0',
  1542: '#6498b7',
  1543: '#f0e2a5',
  1544: '#5ca2aa',
  1545: '#94cf62',
  1546: '#eaa1e3',
  1547: '#feab91'
}



// WEBPACK FOOTER //
// ./src/assets/CountryColor.js